import React from 'react';
import './PuppiesLabel.css'

export default function PuppiesLabel() {
    return (
        <div className={`puppies-label`} >
            <p>PUPPIES ARE ARRIVED!</p>
        </div>
    );
}
